import React from 'react';
import { getLosingKnockedHands } from '../../../utils/handHistoryHelpers';

/**
 * Hand history list for in-table overlays (casino v2).
 */
export default function HandHistoryPanel({ historyArr = [], allSeats = [], creditValue = 1 }) {
  const rounds = Array.isArray(historyArr) ? historyArr : [];

  if (!rounds.length) {
    return (
      <div className="cv2-utility-empty">
        <p className="cv2-utility-empty-title">No hands recorded yet</p>
        <p className="cv2-utility-empty-hint">Completed rounds will appear here after play begins.</p>
      </div>
    );
  }

  return (
    <div className="cv2-utility-list">
      {rounds.slice().map((h, i) => {
        const winnerLabel = Array.isArray(h.winnerIdx)
          ? h.winnerIdx.map((idx) => allSeats[idx]?.name).filter(Boolean).join(', ')
          : allSeats[h.winnerIdx]?.name || 'unknown';
        const losingHands = getLosingKnockedHands(h, allSeats);

        return (
          <article key={`round-${h.round ?? i}-${i}`} className="cv2-utility-card">
            <header className="cv2-utility-card-head">Round {h.round}</header>
            <dl className="cv2-utility-dl">
              <div>
                <dt>Winner{Array.isArray(h.winnerIdx) && h.winnerIdx.length > 1 ? 's' : ''}</dt>
                <dd className="cv2-text-win">{winnerLabel || '—'}</dd>
              </div>
              <div>
                <dt>Dealer</dt>
                <dd>{allSeats[h.dealerIdx]?.name || '—'}</dd>
              </div>
              <div>
                <dt>Winning hand</dt>
                <dd className="cv2-text-accent">{h.winningHand || 'Unknown'}</dd>
              </div>
              <div>
                <dt>Hand type</dt>
                <dd>{h.winningHandType || 'Unknown'}</dd>
              </div>
              {h.pot != null && (
                <div>
                  <dt>Pot</dt>
                  <dd className="cv2-text-accent">
                    {h.pot} chips (${(h.pot * creditValue).toFixed(2)})
                  </dd>
                </div>
              )}
              <div>
                <dt>Knocked</dt>
                <dd>{(h.knocked || []).map((idx) => allSeats[idx]?.name).filter(Boolean).join(', ') || '—'}</dd>
              </div>
              <div>
                <dt>Discarded</dt>
                <dd>
                  {(h.discarded || []).map((idx) => allSeats[idx]?.name).filter(Boolean).join(', ') || '(none)'}
                </dd>
              </div>
            </dl>

            {losingHands.length > 0 && (
              <div className="cv2-utility-subsection">
                <div className="cv2-utility-subtitle">Losing knocked hands</div>
                <ul className="cv2-utility-mini-list">
                  {losingHands.map((entry, li) => (
                    <li key={`${entry.playerIdx}-${li}`} className="cv2-utility-loss">
                      <span className="cv2-utility-loss-name">{entry.playerName}</span>
                      {entry.hand ? (
                        <>
                          {' — '}
                          <span className="cv2-text-loss">{entry.hand}</span>
                          {entry.handType && <span className="cv2-utility-muted"> ({entry.handType})</span>}
                        </>
                      ) : (
                        <span className="cv2-utility-muted"> (hand not recorded)</span>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {h.dealerChanged && (
              <div className="cv2-utility-callout">
                Special win — dealer changed to {allSeats[h.newDealerIdx]?.name || 'unknown'}
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
}
